import {
  GetWebsiteTrackingAndSeoResponse,
  getWebsiteTrackingAndSeo,
} from 'src/editor/api/website-pages-api'
import { BaseQueryWithValidationClass } from './utils/query-with-validation-class'

class WebsiteTrackingAndSeoQueryClass extends BaseQueryWithValidationClass<
  [number],
  GetWebsiteTrackingAndSeoResponse
> {
  queryFn = (pageId: number) => getWebsiteTrackingAndSeo(pageId)
  getQueryKey = (pageId: number) => ['websiteTrackingAndSeo', pageId] as const
}

export const websiteTrackingAndSeoQuery = new WebsiteTrackingAndSeoQueryClass()
